import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { NAME_MIN_LENGTH, NAME_MAX_LENGTH, PHONE_MIN_LENGTH, PHONE_MAX_LENGTH, EMAIL_MIN_LENGTH, EMAIL_MAX_LENGTH } from '../appConstants/appConstants.js';
import { formatPhone } from './phoneNumberUtil.js';

var defaultRegexp = /^[^£$€^!<>(){}=?+;¤%*^~_|.,[\]\\]+$/;
var emailRegexp = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
var stringPhoneRegExp = "^[+]{0,1}[0-9]{".concat(PHONE_MIN_LENGTH, ",").concat(PHONE_MAX_LENGTH, "}$");
var phoneRegexp = new RegExp(stringPhoneRegExp);
var zipRegexp = /^[A-Z0-9]*$/;
var guardAccessInputRegexp = /['"‘’“”]/;
var isString = function isString(str) {
  return typeof str === 'string';
};
var isLetter = function isLetter(ch) {
  return isString(ch) && ch.toLowerCase() !== ch.toUpperCase();
};
var isDigit = function isDigit(dg) {
  return /^\d+$/.test(dg);
};
var isSpace = function isSpace(sp) {
  return /^ +$/.test(sp);
};
var isSpecialCharFromMGW = function isSpecialCharFromMGW(ch) {
  return /['#@&"/:-]/.test(ch);
};

// eslint-disable-next-line max-len
// https://opengrok.dev.verisure.com/xref/vapi-conversion/src/main/java/com/sdi/vapi/conversion/VapiConversionUtil.java#357
var isValidSbnCharacter = function isValidSbnCharacter(ch) {
  if (ch >= " " && ch <= "~") {
    return true;
  }
  if (ch >= "\xA0" && ch <= "\xFF") {
    return true;
  }
  return false;
};
var isValidLikeMGW = function isValidLikeMGW(str) {
  return isString(str) && _toConsumableArray(str).every(function (ch) {
    return isValidSbnCharacter(ch) && (isLetter(ch) || isDigit(ch) || isSpace(ch) || isSpecialCharFromMGW(ch));
  });
};
var isNameValid = function isNameValid(name) {
  return isString(name) && name.trim().length >= NAME_MIN_LENGTH && name.length <= NAME_MAX_LENGTH && defaultRegexp.test(name);
};
var isPhoneNumberValid = function isPhoneNumberValid(phoneNumber) {
  return isString(phoneNumber) && phoneNumber.trim().length >= PHONE_MIN_LENGTH && formatPhone(phoneNumber).length <= PHONE_MAX_LENGTH && phoneRegexp.test(phoneNumber);
};
var isEmailValid = function isEmailValid(email) {
  return isString(email) && email.trim().length >= EMAIL_MIN_LENGTH && email.length <= EMAIL_MAX_LENGTH && emailRegexp.test(email);
};
var isZipCodeValid = function isZipCodeValid(zipCode, zipCodeRegex) {
  if (!zipCodeRegex) {
    return zipRegexp.test(zipCode);
  }
  var regExp = new RegExp(zipCodeRegex);
  return regExp.test(zipCode);
};
var isValidGuardAccessInput = function isValidGuardAccessInput(value) {
  return !guardAccessInputRegexp.test(value);
};

export { isDigit, isEmailValid, isLetter, isNameValid, isPhoneNumberValid, isSpace, isSpecialCharFromMGW, isValidGuardAccessInput, isValidLikeMGW, isValidSbnCharacter, isZipCodeValid };
